import { Nullable } from '@/shared/types/app.types'

export interface VtLoadingViewState {
    promise: Nullable<Promise<any>>
}
export const initialVtLoadingViewState =
    (): VtLoadingViewState => ({
        promise: null
    })
